












































































































































































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import AddOrEdit from './parts/addOrEdit.vue'
import AddOrEditLlx from './parts/addOrEditLlx.vue'
import AddOrEditNlrs from './parts/addOrEditNlrs.vue'
import AddOrEditSjmbg from './parts/addOrEditSjmbg.vue'
import AddOrEditSjmzgrs from './parts/addOrEditSjmzgrs.vue'
import AddOrEditSjmzgszq from './parts/addOrEditSjmzgszq.vue'
import AddOrEditSdsdg from './parts/addOrEditSdsdg.vue'
import AddOrEditWgs from './parts/addOrEditWgs.vue'
import AddOrEditXygl from './parts/addOrEditXygl.vue'
import {GetDocNlcxs, GetPatDocList} from "@/api/hd"

@Component({
	components: {AddOrEdit, AddOrEditLlx, AddOrEditNlrs, AddOrEditSjmbg, AddOrEditXygl,
		AddOrEditSjmzgrs, AddOrEditSjmzgszq, AddOrEditSdsdg, AddOrEditWgs}
})
export default class MedDoc extends AbpBase {
	@Prop() patient:any
	// vue 不允许更改父组件传递来的值，所以复制一份使用
	patientCopy:any = {}
	data:any = {
		nlcx:{
			nlcxs:[]
		},
		nlxx:{
			nlxx:[]
		},
		sdsdg:{
			sdsdg:[]
		},
		sjmbgs:{
			sjmbgs:[]
		},
		sjmzg:{
			sjmzg:[]
		},
		sjmzgs:{
			sjmzgs:[]
		},
		szdt:{
			szdt:[]
		},
		wgszl:{
			wgszl:[]
		},
		xXgl: {
			xxgl:[]
		}
	}
	addOrEditShow: boolean = false
	addOrEditData: any = {}
	addOrEditLlxShow: boolean = false
	addOrEditNlrsShow: boolean = false
	addOrEditSjmbgShow: boolean = false
	addOrEditSjmzgShow: boolean = false
	addOrEditSjmzgszqShow: boolean = false
	addOrEditSdsdgShow: boolean = false
	addOrEditWgsShow: boolean = false
	addOrEditXyglShow: boolean = false

	created(){
		this.init()
	}
	addOne(name:string){
		const _this = this
		switch(name){
			case '动静脉内瘘成形术知情同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditShow = true
				break
			case '连续性肾脏替代治疗同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditLlxShow = true
				break
			case '内瘘溶栓同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditNlrsShow = true
				break
			case '深静脉拔管同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmbgShow = true
				break
			case '深静脉置管溶栓同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmzgShow = true
				break
			case '深静脉置管术知情同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmzgszqShow = true
				break
			case '隧道式导管知情同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSdsdgShow = true
				break
			case '无肝素透析知情同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditWgsShow = true
				break
			case '血液灌流知情同意书':
				this.addOrEditData = {
					mode: 'add',
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditXyglShow = true
				break
		}

	}
	editOnt(name:string, item:any){
		const _this = this
		switch(name){
			case '动静脉内瘘成形术知情同意书':
				this.addOrEditData = {
					mode: 'edit',
					item: item,
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditShow = true
				break
			case '连续性肾脏替代治疗同意书':
				this.addOrEditData = {
					mode: 'edit',
					item: item,
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditLlxShow = true
				break
			case '内瘘溶栓同意书':
				this.addOrEditData = {
					mode: 'edit',
					item: item,
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditNlrsShow = true
				break
			case '深静脉拔管同意书':
				this.addOrEditData = {
					mode: 'edit',
					item: item,
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmbgShow = true
				break
			case '深静脉置管溶栓同意书':
				this.addOrEditData = {
					mode: 'edit',
					item: item,
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmzgShow = true
				break
			case '深静脉置管术知情同意书':
				this.addOrEditData = {
					mode: 'edit',
					item: item,
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSjmzgszqShow = true
				break
			case '隧道式导管知情同意书':
				this.addOrEditData = {
					mode: 'edit',
					item: item,
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditSdsdgShow = true
				break
			case '无肝素透析知情同意书':
				this.addOrEditData = {
					mode: 'edit',
					item: item,
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditWgsShow = true
				break
			case '血液灌流知情同意书':
				this.addOrEditData = {
					mode: 'edit',
					item: item,
					name: name,
					patient: _this.patientCopy
				}
				this.addOrEditXyglShow = true
				break
		}
	}
	async init(){
		let res = await GetPatDocList({PatientId: this.patient.id})
		console.log(res.objects)
		this.data = res.objects
		let res1 = await GetDocNlcxs({PatientId: this.patient.id})
		this.patientCopy = {...this.patient, ...res1.objects.patient}
	}
	saveSuccess(){
		this.addOrEditShow = false
		this.addOrEditLlxShow = false
		this.addOrEditNlrsShow = false
		this.addOrEditSjmbgShow = false
		this.addOrEditSjmzgShow = false
		this.addOrEditSjmzgszqShow = false
		this.addOrEditSdsdgShow = false
		this.addOrEditWgsShow = false
		this.addOrEditXyglShow = false
		this.init()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/medDoc/index.vue